
import { defineComponent, ref } from "vue";
import {
    getCloudClassRoomDetail,
    getCloudClassrecommend,
    putVisitsCount,
} from "@/api/CloudClassRoomAPI";
import { GetVideoToken } from "@/api/videoAPI";
import { useRouter, useRoute } from "vue-router";



const loadRelease = new Promise(async (r) => {
    const jsArr = [
        loadCss(
            "https://web.sdk.qcloud.com/player/tcplayer/release/v4.2.1/tcplayer.min.css"
        ),
        loadScript(
            "https://web.sdk.qcloud.com/player/tcplayer/release/v4.2.1/libs/hls.min.0.13.2m.js"
        ),
        loadScript(
            "https://web.sdk.qcloud.com/player/tcplayer/release/v4.2.1/tcplayer.v4.2.1.min.js"
        ),
    ];
    await Promise.all(jsArr);
    r(true);
});

function loadScript(src) {
    return new Promise((r) => {
        var script = document.createElement("script");
        script.src = src;
        script.onload = function () {
            r(true);
        };
        document.body.appendChild(script);
    });
}
function loadCss(href) {
    return new Promise((r) => {
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;
        link.onload = function () {
            r(true);
        };
        document.body.appendChild(link);
    });
}

export default defineComponent({
    setup() {
        const router = useRouter();
        const route = useRoute();
        const loaded = ref(false);

        return {
            router, route,
            loaded,
        };
    },
    watch: {
        async "id"() {
            await this.loadData();
        },
    },
    props: {
        id: { type: String }
    },
    data() {
        return {
            player: null,
            formData: {} as any,
            formDataRecommend: {} as any,
            learnSpeed: [],
        };
    },
    async mounted() {
        this.$toast.loading({
            message: "加载中...",
            forbidClick: true,
            duration: 0,
        });
        // 加载云点播资源（js,css）
        await loadRelease;
        await this.loadData();
        this.loaded = true;
        this.$toast.clear();
    },
    methods: {
        showMore() {
            this.router.push("/mulin/cloudClass");
        },
        async loadData() {
            let res = await getCloudClassRoomDetail(this.id);
            if (res) {
                this.formData = res;
            }
            // 读取播放视频的配置
            await this.GetVideoToken();
            // 更换云课堂推荐视频
            let res2 = await getCloudClassrecommend(this.id);
            if (res2) {
                this.formDataRecommend = res2;
            }
            // 访问次数更新
            putVisitsCount(this.id);

        },
        showCommend() {
            this.router.replace({ name: this.route.name, params: { id: this.formDataRecommend.id } });
        },
        async GetVideoToken() {
            let response = await GetVideoToken(this.formData.fileId);

            const videoData = {
                fileID: this.formData.fileId,
                appID: response.appId,
                psign: response.token,
            };
            if (this.player) {
                this.player.loadVideoByID(videoData);
                this.learnSpeed = [];
            } else {
                this.initPlayer(videoData);
            }
        },
        initPlayer(data) {
            const opt = {
                ...data,
                height: this.getVideoHeight(),
                // 播放速率
                controlBar: {
                    playbackRateMenuButton: false,
                    // 进度条
                    // progressControl: false,
                    // 是否显示封面
                    posterImage: true,
                },
            };
            // eslint-disable-next-line
            this.player = TCPlayer("player-container-id", opt);
        },
        // reSize() {
        //     this.player.height(this.getVideoHeight());
        //     // document.getElementById('player-container-id').style.height = getVideoHeight() + 'px';
        // },
        getVideoHeight() {
            const height =
                document.getElementById("player-container-id").clientWidth *
                0.5625;
            return parseInt(height.toString());
        },
    },
});
